import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { contactcomp1Component } from '../components/comp1/contactcomp1.component';
import { contactcomp2Component } from '../components/comp2/contactcomp2.component';
import { contactcomp3Component } from '../components/comp3/contactcomp3.component';
import { contactcomp4Component } from '../components/comp4/contactcomp4.component';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [CommonModule, contactcomp1Component, contactcomp2Component, contactcomp3Component, contactcomp4Component],
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class contactComponent {

}